import initReducer from '../lib/init-reducer'
import config from '../components/CopperCoastParticles/config.json'
export default initReducer({default: config }, {
    INIT_PARTICLE: (state, action) => ({ ...state, [action.name]: action.config }),
    SET_PARTICLE_NUMBER: (state, action) => ({ ...state, [action.name]: {
        ...state[action.name], particles: {
            ...state[action.name].particles, number: {
                ...state[action.name].particles.number,
                value: action.number
                }
            }
        }
    }),
    SET_COLOUR: (state, action) => ({ ...state, [action.name]: {
        ...state[action.name], particles: {
            ...state[action.name].particles, line_linked: {
                ...state[action.name].particles.line_linked,
                color: action.colour
            }
        }
    }
    })
})


// WEBPACK FOOTER //
// ./src/reducers/ParticlesReducer.js